import { PersonLogin } from "../person/person-login";

export class FpaTaskResponse {
  taskId!: number;
  responder!: PersonLogin;
  additionalData!: string;
  approved!: boolean;
  requestedMultiplier!: number;
  comments!: string;
}

